import createAdapter from './createAdapter'
import { environment } from 'js/config'
import { getItem } from 'js/storeManager'

const events = {
  PageView: () => {
    return {
      com: '5fa954714769607e78fb527c',
      ft: '5fbfbb0b150681b873fc9217',
      ftde: '5fca5234d4489aed74895b2d',
      ft30: '5fcf86e5ef6162d0609552ab',
    }
  },
  'Select Goal': ({ goal }) => {
    if (goal === 'Lose')
      return {
        com: '5fa954d94769607e78fb527e',
        ft: '5fbfbb31fab9ca84759a37d1',
        ftde: '5fca525cd4489aed74895b31',
        ft30: '5fcf8f81a0a8fb615e5903ec',
      }
    if (goal === 'Gain')
      return {
        com: '5fa955f88180f21b0ad2cc39',
        ft: '5fbfbb207f2e7a11743d1471',
        ftde: '5fca5218064ac7eb6b8b1019',
        ft30: '5fcf870bc06327496180f36c',
      }
    if (goal === 'Maintain')
      return {
        com: '5fa954ee535f9a59a2d76813',
        ft: '5fbfbb43950697b774b798d6',
        ftde: '5fca5284064ac7eb6b8b101a',
        ft30: '5fcf8fbb6703b31c6265c4ba',
      }
  },
  'Enter Basic Information': () => {
    return {
      com: '5fa954ee535f9a59a2d76813',
      ft: '5fbfbb52150681b873fc9218',
      ftde: '5fca5299064ac7eb6b8b101b',
      ft30: '5fcf8ff0c06327496180f37e',
    }
  },
  'Choose Registration Method': ({ method }) => {
    if (method === 'facebook') {
      return {
        com: '5fa957818180f21b0ad2cc3e',
        ft: '5fbfbb63150681b873fc9219',
        ftde: '5fca52dcd4489aed74895b32',
        ft30: '5fcf9049ef6162d0609552bb',
      }
    }

    return {
      com: '5fa9579c8180f21b0ad2cc3f',
      ft: '5fbfbba8fab9ca84759a37d2',
      ftde: '5fca52ca9fc6e1e071b8b744',
      ft30: '5fcf902174ca579d5f186d59',
    }
  },
  'Select Premium Subscription': () => {
    return {
      com: '5faaa743da7ba33666869b61',
      ft: '5fbfbbb8d9547d3274411855',
      ftde: '5fca53049fc6e1e071b8b745',
      ft30: '5fcf90616703b31c6265c4be',
    }
  },
  Purchase: () => {
    return {
      com: '5faaa7b42dedbae7f2e7ecf6',
      ft: '5fbfbbc974cfa5eb766d6222',
      ftde: '5fca531cd4489aed74895b34',
      ft30: '5fcf908b50dd231c697449b6',
    }
  },
  'Premium account created': () => {
    return {
      com: '5faaa7e62c52cac466c95a30',
      ft: '5fbfbbea7f2e7a11743d1473',
      ftde: '5fca5338ec1435c471a2b1ac',
      ft30: '5fcf90b450dd231c697449b8',
    }
  },
}

const version = () => {
  const storedState = getItem('state')
  const state = storedState ? JSON.parse(storedState) : null
  const de = state?.locale?.language === 'de'

  const ft =
    getItem('EntryPoint') === 'FreeTrialSignup' ||
    window.location.pathname.startsWith('/free-trial-signup')

  const ft30 =
    getItem('EntryPoint') === 'FreeTrial30' ||
    window.location.pathname.startsWith('/free-trial-30')

  if (ft && !de) return 'ft'
  if (ft && de) return 'ftde'
  if (ft30) return 'ft30'
  return 'com'
}

function addScript(id) {
  var head = document.getElementsByTagName('head')[0]

  var script = document.createElement('script')
  script.src = `https://ads.avocet.io/s?add=${id}&ty=j`
  script.type = 'text/javascript'

  head.appendChild(script)
}

function trackInstall({ type }) {
  if (
    window.location.pathname.startsWith('/news/') &&
    environment === 'production'
  ) {
    return addScript(
      {
        apple: '5fd3abc870d9781a15a4c124',
        google: '5fd3abdea37caaf01d58a9a3',
      }[type]
    )
  }
  if (environment !== 'test') {
    console.log(['Avocet:', 'Install', type])
  }
}

export const avocet = createAdapter(() => !!window.fetch, {
  page() {
    if (environment === 'production') addScript(events['PageView']()[version()])
  },
  track(eventName, props) {
    if (eventName === 'Install') return trackInstall(props)

    const id = events[eventName] && events[eventName](props)[version()]

    if (!eventName || !id) {
      throw new Error(
        `avocetAdapter: eventName: "${eventName}" does not exist (props: "${
          props && JSON.stringify(props)
        }", version: "${version()}")`
      )
    }

    if (environment === 'production') {
      return addScript(id)
    }
    if (environment !== 'test') {
      return console.log(['Avocet:', eventName, version()])
    }
  },
})
